/**
 * A key decision as defined in key-decisions.json.
 * Constructor parameters are injected in KeyDecisionConfig.js.
 */
export default class KeyDecisionDefinition {
    constructor(id, chapter, contentId, backgroundImageId) {
        this._id = id;
        this._chapter = chapter;
        this._contentId = contentId;
        this._backgroundImageId = backgroundImageId;
    }

    get id() {
        return this._id;
    }

    get chapter() {
        return this._chapter;
    }

    get contentId() {
        return this._contentId;
    }

    get backgroundImageId() {
        return this._backgroundImageId;
    }
}